import { memo } from 'react';
import { Stack } from '@mui/material';
import { useToggle } from '@dfl/hook-utils';
import { useDeleteKeyword } from 'modules/cms/seo/keyword/hooks/useDeleteKeyword';
import { DeleteRowAction, EditRowActions } from '@dfl/mui-admin-layout';
import { useParamsLink } from '@dfl/react-security';

type UserStatusProps = {
  rowId: string;
};

const KeywordRowActions = ({ rowId }: UserStatusProps) => {
  const { isOpen, onClose, onOpen } = useToggle();
  const handleEdit = useParamsLink({ editKeyword: rowId });
  const { mutate, isPending, error } = useDeleteKeyword(rowId, onClose);
  return (
    <>
      <Stack direction='row' spacing={1} justifyContent={'center'}>
        <EditRowActions onClick={handleEdit} />
        <DeleteRowAction
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={onClose}
          error={error}
          isLoading={isPending}
          onDelete={mutate}
        />
      </Stack>
    </>
  );
};

export default memo(KeywordRowActions);
